var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerbLiveText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220px",
    height: "36px",
    viewBox: "0 0 220 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo / live ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 32.3912224 0 32.3912224 24.3738853 0 24.3738853"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 31.3095081 0 31.3095081 35.2528781 0 35.2528781"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v40-434",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-434-2",
    transform: "translate(-850.000000, -327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(803.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-/-live-",
    transform: "translate(47.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3118,19.8465781 C39.1218,17.2455781 42.0838,15.6535781 45.6398,15.8625781 C48.7558,16.0455781 51.1158,17.6065781 51.5638,19.8465781 L38.3118,19.8465781 Z M56.1318,13.3555781 C50.6128,8.58457806 40.5228,8.40657806 34.5568,12.9185781 C28.0238,17.8595781 28.2398,27.6525781 34.9838,32.2915781 C40.5068,36.0915781 49.8728,36.2695781 55.4608,32.5375781 C56.8258,31.6255781 57.9828,30.3495781 59.0748,29.1005781 C59.9748,28.0715781 59.8038,27.7735781 58.5148,27.4495781 C57.2388,27.1295781 55.9328,26.9045781 54.6838,26.5005781 C53.2718,26.0435781 53.1098,25.9695781 51.3068,27.3275781 C50.9068,27.6285781 50.1978,28.0315781 49.6908,28.2445781 C46.8178,29.4575781 43.9198,29.3345781 41.0928,28.1475781 C39.6998,27.5625781 38.6698,26.5025781 38.2038,24.7965781 L39.6788,24.7965781 C45.9548,24.7965781 52.2308,24.7905781 58.5068,24.8025781 C59.2378,24.8045781 59.8948,24.7965781 59.9678,23.8395781 C60.2818,19.7615781 59.3308,16.1205781 56.1318,13.3555781 L56.1318,13.3555781 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-0.000000, 10.185847)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.065,0.0983311743 C29.166,0.0163311743 27.385,-0.0556688257 25.552,0.0613311743 C23.929,0.196331174 23.37,0.504331174 22.782,1.82433117 C20.708,6.48133117 18.506,11.0823312 16.248,15.9283312 C16.026,15.4903312 15.895,15.2483312 15.779,15.0003312 C13.617,10.3773312 11.446,5.76033117 9.309,1.12633117 C8.963,0.378331174 8.527,0.0973311743 7.665,0.0763311743 C5.464,0.0223311743 3.34,0.0623311743 1.191,0.100331174 C-0.073,0.122331174 -0.26,0.400331174 0.297,1.51633117 C3.969,8.86833117 7.638,16.2213312 11.356,23.5503312 C11.549,23.9313312 12.175,24.3043312 12.611,24.3183312 C14.966,24.3943312 17.326,24.3233312 19.684,24.3733312 C20.445,24.3883312 20.817,24.0993312 21.143,23.4433312 C24.759,16.1523312 28.403,8.87633117 32.037,1.59433117 C32.668,0.329331174 32.521,0.103331174 31.065,0.0983311743",
    id: "Fill-3",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.417,11.1400781 C80.455,10.2280781 80.077,9.99307806 79.23,9.95007806 C76.241,9.79807806 73.525,10.4200781 71.088,12.7580781 C71.088,12.2590781 71.09,12.0640781 71.088,11.8690781 C71.071,10.2860781 71.071,10.2850781 69.511,10.2830781 C67.673,10.2820781 65.835,10.3080781 63.998,10.2710781 C63.146,10.2550781 62.7639819,10.5420781 62.766,11.4410781 C62.785,18.7920781 62.786,26.1420781 62.7639819,33.4930781 C62.761,34.3650781 63.131,34.5710781 63.921,34.5530781 C65.758,34.5130781 67.596,34.5400781 69.434,34.5400781 C71.087,34.5400781 71.065,34.5400781 71.092,32.8500781 C71.151,29.1400781 71.114,25.4230781 71.353,21.7240781 C71.502,19.4170781 72.762,17.5980781 75.121,16.9950781 C76.397,16.6690781 77.783,16.6840781 79.117,16.7050781 C80.01,16.7200781 80.464,16.5980781 80.418,15.5730781 C80.351,14.0980781 80.356,12.6160781 80.417,11.1400781",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(82.904492, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5250081,27.3549781 C19.0670081,28.3819781 17.4370081,28.8189781 15.7960081,28.7679781 C11.7420081,28.7679781 8.85800813,26.5839781 8.26500813,23.1449781 C7.98900813,21.5459781 8.47200813,20.1139781 9.44200813,18.8839781 C12.1080081,15.5019781 18.2280081,15.1549781 21.2850081,18.1709781 C23.9950081,20.8439781 23.6380081,25.1609781 20.5250081,27.3549781 M22.9760081,10.8069781 C18.0110081,8.92897806 13.1130081,9.21697806 8.38300813,12.3419781 C8.38300813,8.52497806 8.35700813,4.88697806 8.40200813,1.24997806 C8.41300813,0.293978058 8.07200813,-0.0200219416 7.14800813,0.000978058369 C5.18900813,0.0449780584 3.22800813,0.0439780584 1.26900813,0.000978058369 C0.343008128,-0.0190219416 -0.000991872206,0.311978058 0.00100812779,1.25697806 C0.0230081278,11.9759781 0.0230081278,22.6949781 -1.77635684e-15,33.4139781 C-0.00199187221,34.3379781 0.365008128,34.5769781 1.21600813,34.5549781 C2.97500813,34.5079781 4.73500813,34.5399781 6.49500813,34.5399781 C8.29400813,34.5399781 8.29300813,34.5409781 8.41000813,32.8069781 C8.41300813,32.7549781 8.49900813,32.7079781 8.58600813,32.6169781 C12.4240081,35.3399781 16.6820081,35.7979781 21.1430081,34.6989781 C27.1790081,33.2119781 31.1190081,28.7099781 31.3030081,22.7559781 C31.4630081,17.6089781 28.7170081,12.9779781 22.9760081,10.8069781",
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LIVE",
    transform: "translate(124.682404, 0.996154)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 33.4653846 22.1349615 33.4653846 22.1349615 31.1706154 2.486 31.1706154 2.486 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "27.3175962 33.4653846 29.8035962 33.4653846 29.8035962 0 27.3175962 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "49.0423654 33.7044231 51.2415192 33.7044231 65.9662885 0 63.3368654 0 50.18975 30.7881538 37.0904423 0 34.3175962 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "70.3175962 33.4653846 94.3648654 33.4653846 94.3648654 31.1706154 72.8035962 31.1706154 72.8035962 17.7366538 91.9744808 17.7366538 91.9744808 15.4418846 72.8035962 15.4418846 72.8035962 2.29476923 94.1258269 2.29476923 94.1258269 0 70.3175962 0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbLiveText);
export default __webpack_public_path__ + "static/media/verb-live-text.f0316e314e67685c0615d82d4b5622c9.svg";
export { ForwardRef as ReactComponent };